import { render, staticRenderFns } from "./Exam.vue?vue&type=template&id=a98a409c"
import script from "./Exam.vue?vue&type=script&lang=ts"
export * from "./Exam.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports